//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    label: function label() {
      return this.$t("".concat(this.id, ".label"));
    },
    info: function info() {
      return this.$te("".concat(this.id, ".info")) ? this.$t("".concat(this.id, ".info")) : null;
    }
  }
};